import {Component, OnInit} from '@angular/core';
import {TaskFormComponent} from "./task-form/task-form.component";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {Button} from "primeng/button";
import {TaskListComponent} from "./task-list/task-list.component";
import {MessageService} from "primeng/api";
import {TaskDetailsComponent} from "./task-details/task-details.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-task',
    standalone: true,
    imports: [
        Button,
        TaskListComponent,
        TranslateModule
    ],
    providers: [DialogService, TaskFormComponent, MessageService],
    templateUrl: './task.component.html',
    styleUrl: './task.component.scss'
})
export class TaskComponent implements OnInit {

    ref: DynamicDialogRef | undefined;

    constructor(public dialogService: DialogService) {
    }

    ngOnInit(): void {

    }


    showForm() {


        this.ref = this.dialogService.open(TaskFormComponent,
            {
                header: 'Add new Task'
            }
        );


        this.ref.onClose.subscribe(result => {
            console.log('Closed with: ', result);
        });
    }

    showDetails() {


        this.ref = this.dialogService.open(TaskDetailsComponent,
            {
                header: 'Task Details'
            }
        );


        this.ref.onClose.subscribe(result => {
            console.log('Closed with: ', result);
        });
    }


}
